<template>
  <div>
    <draggable
      :disabled="false"
      :list="questions"
      ghost-class="ghost"
      v-bind="dragOptions"
      @change="changeColumn"
    >
      <div v-for="(question, index) in questions" :key="index" class="row mb-3">
        <div class="col-lg-12">
          <div class="position-relative">
            <div
              class="close radius-0"
              style="right: 0px"
              @click="deleteQuestion(index)"
            >
              <i class="fa fa-times f10" style="margin-bottom: 7px"></i>
            </div>
            <div class="formJov">
              <div class="pt-3" style="text-align: left">
                <ul class="nav nav-tabs">
                  <li
                    v-for="tab in questions[index].tabs"
                    :key="tab.name"
                    class="nav-item"
                  >
                    <button
                      :class="tab.active ? 'btn-primary' : 'btn-light bg-white'"
                      class="pointer btn py-2 px-5 radius-0"
                      @click="showTab(tab, index)"
                    >
                      {{ tab.name }}
                    </button>
                  </li>
                </ul>
              </div>
              <div class="card-body p-0 mt-2">
                <div
                  v-if="question.tabs[0].active"
                  :id="question.tabs[0].name"
                  :aria-labelledby="`${question.tabs[0].name}-tab`"
                  :class="{
                    active: question.tabs[0].active,
                    show: question.tabs[0].active,
                    fade: !question.tabs[0].active,
                  }"
                  class="tab-pane"
                >
                  <label>TÍTULO DA PERGUNTA</label>
                  <ckeditor
                    v-if="!loading_title"
                    v-model="questions[index].title"
                    class="mt-2"
                    @blur="updateQuestions(false, index)"
                  />
                  <input
                    v-model="questions[index].details"
                    class="mt-3 form-control"
                    placeholder="ADICIONE DETALHES (OPCIONAL)"
                    type="text"
                    @change="updateQuestions()"
                  />
                </div>
                <div class="mt-3 d-flex">
                  <SwitchCheckbox
                    v-model="questions[index].choices.canBeEmpty"
                    label="Pode ser vazio?"
                    style="color: black"
                    @input="updateQuestions(false, index)"
                  />
                </div>
                <!--                <div class="mt-3 d-flex">-->
                <!--                  <SwitchCheckbox-->
                <!--                    label="Obrigatória"-->
                <!--                    v-model="questions[index].is_mandatory"-->
                <!--                    @input="updateQuestions(false, index)"-->
                <!--                  />-->
                <!--                </div>-->
                <div
                  v-if="question.tabs[1].active"
                  :id="question.tabs[1].name"
                  :aria-labelledby="`${question.tabs[1].name}-tab`"
                  :class="{
                    active: question.tabs[1].active,
                    show: question.tabs[1].active,
                    fade: !question.tabs[1].active,
                  }"
                  class="tab-pane"
                >
                  <div
                    v-if="
                      question.tabs[1].options.record_now == false &&
                      question.tabs[1].options.upload_video == false
                    "
                    class="row"
                  >
                    <div class="col-lg-12 col-xs-12">
                      <label>TÍTULO DA PERGUNTA</label>
                      <ckeditor
                        v-model="questions[index].title"
                        class="mt-2"
                        @blur="updateQuestions(false, index)"
                      />
                    </div>
                    <div class="mb-2 col-lg-12 col-xs-12">
                      <div :id="`canvas${index}`" class="hide"></div>
                      <div class="videoPlayCurrent">
                        <video
                          v-show="questions[index].video"
                          :id="`videoQuestion${index}`"
                          class="mt-2"
                          controls
                          controlslist="nodownload"
                          width="100%"
                        >
                          <source :src="questions[index].video" />
                        </video>
                      </div>
                      <transition name="fade">
                        <KProgress
                          v-if="percent > 0 && percent <= 99"
                          :color="['#53358B', '#00baf7']"
                          :percent="percent"
                          bg-color="#fff"
                        />
                      </transition>
                    </div>
                    <div class="col-lg-4 col-xs-12">
                      <button
                        class="btn full f13 radius-0 p-2 btn-primary btn-rezise-ask"
                        @click="canVideo(index)"
                      >
                        GRAVAR
                      </button>
                    </div>
                    <div class="col-lg-4 col-xs-12">
                      <span
                        :disabled="question.title == ''"
                        class="btn f13 p-2 radius-0 full btn-success btn-default btn-file btn-rezise-ask"
                      >
                        UPLOAD
                        <input
                          :id="`capture${index}`"
                          :ref="`file${index}`"
                          accept="video/*"
                          capture="camcorder"
                          type="file"
                          @click="canUpload(index, $event)"
                          v-on:change="sendMovieUpload(index)"
                        />
                      </span>
                    </div>
                    <div class="col-lg-4 col-xs-12">
                      <button
                        :disabled="load"
                        class="btn f13 p-2 radius-0 btn-info full btn-rezise-ask"
                        @click="showSelectVideo(index)"
                      >
                        <span v-show="!load">GALERIA</span>
                        <div
                          v-show="load"
                          class="spinner-border text-light"
                          role="status"
                        >
                          <span class="sr-only"></span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  v-if="questions[index].tabs[1].options.record_now == true"
                  class="videoPlayCurrent"
                >
                  <VideoJSRecord
                    :index="index"
                    :job_id="job_id"
                    :question="question"
                    :recruiter="true"
                  />
                  <button
                    class="mt-3 btn-primary btn-sm"
                    @click="backMenuVideo(index)"
                  >
                    <font-awesome-icon class="mr-2" icon="chevron-left" />Voltar
                  </button>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12">
                  <label
                    >Deseja que a resposta do candidato(a) seja por:
                  </label>
                  <select
                    v-model="questions[index].response_type"
                    class="form-control"
                    @change="updateQuestions(false, index)"
                  >
                    <option
                      v-for="response in response_types"
                      :key="response.value"
                      :value="response.type"
                    >
                      {{ response.value }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="questions[index].response_type == 2" class="row mt-3">
                <MultipleChoices
                  v-model="questions[index].choices"
                  :index="index"
                />
              </div>
              <div v-if="questions[index].response_type == 3" class="row mt-3">
                <YesOrNo v-model="questions[index].choices" :index="index" />
              </div>
              <div v-if="questions[index].response_type == 4" class="mt-3">
                <Monetary v-model="questions[index].choices" :index="index" />
              </div>

              <div v-if="questions[index].response_type == 0" class="row">
                <div class="col-lg-6 col-xs-12 mt-3">
                  <label>NÚMERO DE TENTATIVAS</label>
                  <select
                    v-model="questions[index].number_retakers"
                    class="form-control"
                    @change="updateQuestions()"
                  >
                    <option value="3">3</option>
                    <option value="5">5</option>
                    <option value="7">7</option>
                  </select>
                </div>
                <div class="col-lg-6 col-xs-12 mt-3">
                  <label>TEMPO LIMITE</label>
                  <select
                    v-model="questions[index].time"
                    class="form-control"
                    style="text-transform: uppercase"
                    @change="updateQuestions()"
                  >
                    <option value="30">30 segundos</option>
                    <option value="60">60 segundos</option>
                    <option value="90">90 segundos</option>
                    <option value="120">120 segundos</option>
                    <option value="180">180 segundos</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-xs-12 mt-3">
                  <label>PROVA</label>
                  <select
                    v-model="questions[index].evaluation_id"
                    class="form-control"
                    @change="updateQuestions(false, index)"
                  >
                    <template v-for="eva in evaluations">
                      <option :key="eva.id" :value="eva.id">
                        {{ eva.name }}
                      </option>
                    </template>
                  </select>
                </div>
                <div class="col-lg-6 col-xs-12 mt-3">
                  <label>TIPO DE ORDENACAO</label>
                  <select
                    v-model="questions[index].type_order"
                    class="form-control"
                    @change="updateQuestions(false, index)"
                  >
                    <option :value="0">Ordenado</option>
                    <option :value="1">Aleatório</option>
                    <option :value="2">Por ultimo</option>
                    <option :value="3">Primeiro</option>
                    <option :value="4">Início</option>
                  </select>
                </div>
                <div
                  v-if="questions[index].response_type != 0"
                  class="col-lg-6 mt-3"
                >
                  <label>TEMPO LIMITE PARA RESPONDER <br />(em segundos)</label>
                  <input
                    v-model.number="questions[index].time_to_respond"
                    class="form-control"
                    type="number"
                    @change="updateQuestions(false, index)"
                  />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12">
                  <label>EM QUAL ETAPA ESTÁ PERGUNTA IRÁ: </label>
                  <select
                    v-model="questions[index].selective_process_id"
                    class="form-control col-xl-12"
                    style="text-transform: uppercase"
                    @change="updateQuestions(true)"
                  >
                    <option
                      v-for="selective_process in selective_processes"
                      :key="selective_process.id"
                      :value="selective_process.id"
                      class="form-control"
                    >
                      {{ selective_process.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <textarea
                    v-model="questions[index].description"
                    class="form-control mt-3 mb-3 border-radius-pattern"
                    placeholder="DESCRIÇÃO DA PERGUNTA (USO APENAS PARA O RECRUTADOR(A))"
                    rows="3"
                    @change="updateQuestions()"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import VideoJSRecord from "components/VideoJSRecord.vue";
import KProgress from "k-progress";
import SelectVideo from "@/Recruiters/Galleries/SelectVideo.vue";
import draggable from "vuedraggable";
import MultipleChoices from "./MultipleChoices.vue";
import YesOrNo from "./YesOrNo.vue";
import Monetary from "./Monetary.vue";
import SwitchCheckbox from "../Jobs/SwitchCheckbox.vue";

export default {
  props: ["job_id", "questions_record", "value"],
  components: {
    SwitchCheckbox,
    MultipleChoices,
    draggable,
    VideoJSRecord,
    KProgress,
    YesOrNo,
    Monetary,
  },
  mounted() {
    if (this.job_id) {
      axios
        .get("/recruiters/evaluations?job_id=" + this.job_id)
        .then(({ data }) => {
          this.evaluations = data.evaluations;
        });
    }
    this.questions = [];
    for (let index in this.questions_record) {
      this.questions.push({
        id: this.questions_record[index].id,
        title: this.questions_record[index].title,
        description: this.questions_record[index].description,
        time: this.questions_record[index].time,
        number_retakers: this.questions_record[index].number_retakers,
        details: this.questions_record[index].details,
        thumbnail: this.questions_record[index].thumbnail,
        video: this.questions_record[index].video,
        deleted: this.questions_record[index].deleted,
        job_id: this.job_id,
        evaluation_id: this.questions_record[index].evaluation_id,
        video_id: this.questions_record[index].video_id,
        response_type: this.questions_record[index].response_type,
        choices: this.questions_record[index].choices,
        selective_process_id: this.questions_record[index].selective_process_id,
        type_order: this.questions_record[index].type_order,
        time_to_respond: this.questions_record[index].time_to_respond,
        is_mandatory: this.questions_record[index].is_mandatory,
        tabs: [
          {
            name: "TEXTO",
            active: this.questions_record[index].video_id ? false : true,
          },
          {
            name: "VÍDEO",
            active: this.questions_record[index].video_id ? true : false,
            options: {
              record_now: false,
              upload_video: false,
            },
          },
        ],
      });
    }

    eventBus.$on("updateQuestions", (questions) => {
      for (let index in questions) {
        this.questions.push({
          id: questions[index].id,
          title: questions[index].title,
          description: questions[index].description,
          time: questions[index].time,
          number_retakers: questions[index].number_retakers,
          details: questions[index].details,
          evaluation_id: this.questions[index].evaluation_id,
          thumbnail: questions[index].thumbnail,
          video: questions[index].video,
          job_id: this.job_id,
          video_id: questions[index].video_id,
          response_type: questions[index].response_type,
          choices: questions[index].choices,
          selective_process_id: this.default_process_id,
          type_order: questions[index].type_order,
          time_to_respond: questions[index].time_to_respond,
          is_mandatory: questions[index].is_mandatory,
          tabs: [
            {
              name: "TEXTO",
              active: questions[index].video_id ? false : true,
            },
            {
              name: "VÍDEO",
              active: questions[index].video_id ? true : false,
              options: {
                record_now: false,
                upload_video: false,
              },
            },
          ],
        });
      }
      this.$emit("input", this.questions);
    });

    eventBus.$on("getQuestions", () => {
      this.getQuestions();
    });

    eventBus.$on("chooseVideo", (video) => {
      this.questions[video.index].video_id = video.id;
      this.questions[video.index].video = video.video;

      this.$modal.hideAll();

      let video_current = document.getElementById(
        `videoQuestion${video.index}`
      );
      video_current.load();
    });

    eventBus.$on("addQuestion", () => {
      this.addQuestion();
    });

    this.$root.$on("columnsChanged", (selective_processes) => {
      this.selective_processes = selective_processes;
      this.default_process_id = selective_processes.filter(
        (process) => process.status === 1
      )[0].id;
    });
  },
  data: () => ({
    evaluations: [],
    load: false,
    loading_title: false,
    percent: 0,
    file: "",
    default_process_id: 0,
    selective_processes: [],
    response_types: [
      { type: 0, value: "Vídeo" },
      { type: 1, value: "Texto" },
      { type: 2, value: "Multipla Escolha" },
      { type: 3, value: "Sim ou não" },
      { type: 4, value: "Válor monetário" },
    ],
    configCkeditor: {
      toolbar: [
        {
          name: "basicstyles",
          groups: ["basicstyles", "cleanup"],
          items: [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "-",
            "RemoveFormat",
            "fontFamily",
            "fontSize",
          ],
        },
        {
          name: "paragraph",
          groups: ["list", "indent", "blocks", "align", "bidi"],
          items: [
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Blockquote",
            "CreateDiv",
            "-",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "BidiLtr",
            "BidiRtl",
            "Language",
          ],
        },
        { name: "tools", items: ["Maximize"] },
        { name: "styles", items: ["FontSize"] },
        { name: "colors", items: ["TextColor", "BGColor"] },
        "/",
      ],
    },
    questions: [
      {
        id: 0,
        title: "",
        description: "",
        time: 30,
        number_retakers: 3,
        details: "",
        video_id: null,
        selective_process_id: 0,
        response_type: 0,
        time_to_respond: 0,
        choices: {},
        is_mandatory: "",
        tabs: [
          {
            name: "TEXTO",
            active: true,
          },
          {
            name: "VÍDEO",
            active: false,
            options: {
              record_now: false,
              upload_video: false,
            },
          },
        ],
      },
    ],
  }),
  methods: {
    getQuestions() {
      axios.get(`/recruiters/questions/${this.job_id}`).then((response) => {
        let questions = response.data.questions;

        for (let index in questions) {
          this.questions[index].id = questions[index].id;
          this.questions[index].title = questions[index].title;
          this.questions[index].description = questions[index].description;
          this.questions[index].time = questions[index].time;
          this.questions[index].number_retakers =
            questions[index].number_retakers;
          this.questions[index].details = questions[index].details;
          this.questions[index].thumbnail = questions[index].thumbnail;
          this.questions[index].video = questions[index].video;
          this.questions[index].job_id = this.job_id;
          (this.questions[index].evaluation_id =
            questions[index].evaluation_id),
            (this.questions[index].video_id = questions[index].video_id);
          this.questions[index].response_type = questions[index].response_type;
          this.questions[index].choices = questions[index].choices;
          this.questions[index].type_order = questions[index].type_order;
          this.questions[index].time_to_respond =
            questions[index].time_to_respond;
          this.questions[index].selective_process_id =
            questions[index].selective_process_id;
          this.questions[index].is_mandatory = questions[index].is_mandatory;
          this.questions[index].tabs = [
            {
              name: "TEXTO",
              active: questions[index].video_id ? false : true,
            },
            {
              name: "VÍDEO",
              active: questions[index].video_id ? true : false,
              options: {
                record_now: false,
                upload_video: false,
              },
            },
          ];
        }
      });
    },
    canUpload(index, event) {
      if (this.questions[index].title == "") {
        this.$toast.error("Digite um título para o vídeo para continuar");
        event.preventDefault();
      }
    },
    showTab(tab, index) {
      this.backMenuVideo(index);
      if (this.questions[index].video_id) {
        let conf = confirm(
          "AO TROCAR DE ABA O VIDEO SERÁ DELETADO E ESSA PERGUNTA SERÁ USADA COMO A ABA INDICA, VOCÊ DESEJA FAZER ISSO?"
        );
        if (!conf) return;
        axios
          .delete(`/recruiters/question_videos/${this.questions[index].id}`)
          .then((response) => {
            if (!response.data.status) {
              this.$toast.error("ERRO AO DELETAR O VÍDEO");
            }
          });
      }
      for (let i in this.questions[index].tabs) {
        this.questions[index].tabs[i].active = false;
      }
      tab.active = true;
    },
    changeColumn: async function (e) {
      this.loading_title = true;
      await eventBus.$emit("saveQuestion", this.questions);
      this.loading_title = false;
    },
    showSelectVideo(index) {
      this.load = true;
      if (this.questions[index].title == "") {
        this.$toast.error("DIGITE UM TÍTULO PARA O VÍDEO PARA CONTINUAR");
        this.load = false;
        return;
      }

      if (this.job_id == 0) {
        eventBus.$emit("saveJob", { index: index });
        setTimeout(() => {
          if (this.job_id != 0) {
            let q_current = this.currentQuestionParams(index);

            axios
              .post("/recruiters/questions", {
                questions: {
                  job_id: this.job_id,
                  itens: [q_current],
                },
              })
              .then((response) => {
                this.questions[index].id = response.data.question.id;
                this.$modal.show(
                  SelectVideo,
                  {
                    index: index,
                    question: this.questions[index],
                  },
                  {
                    width: "75%",
                    height: "auto",
                    scrollable: true,
                  }
                );
                this.load = false;
              });
          } else {
            this.$toast.error(
              "ERRO AO ADICIONAR VIDEO, TENTE CADASTRAR A VAGA PRIMEIRO."
            );
            this.load = false;
          }
        }, 3600);

        return;
      }

      let q_current = this.currentQuestionParams(index);

      axios
        .post("/recruiters/questions", {
          questions: {
            job_id: this.job_id,
            itens: [q_current],
          },
        })
        .then((response) => {
          this.questions[index].id = response.data.question.id;

          this.$modal.show(
            SelectVideo,
            {
              index: index,
              question: this.questions[index],
            },
            {
              width: "75%",
              height: "auto",
              scrollable: true,
            }
          );
        });
      this.load = false;
    },
    currentQuestionParams(index) {
      let q_current = {};
      q_current.id = this.questions[index].id;
      q_current.title = this.questions[index].title;
      q_current.description = this.questions[index].description;
      q_current.time = this.questions[index].time;
      q_current.number_retakers = this.questions[index].number_retakers;
      q_current.details = this.questions[index].details;
      q_current.job_id = this.questions[index].job_id;
      q_current.video_id = this.questions[index].video_id;
      q_current.evaluation_id = this.questions[index].evaluation_id;
      q_current.response_type = this.questions[index].response_type;
      q_current.choices = this.questions[index].choices;
      q_current.type_order = this.questions[index].type_order;
      q_current.selective_process_id =
        this.questions[index].selective_process_id;

      q_current.time_to_respond = this.questions[index].time_to_respond;
      q_current.is_mandatory = this.questions[index].is_mandatory;
      return q_current;
    },
    sendMovieUpload(index) {
      if (this.questions[index].title == "") {
        this.$toast.error("DIGITE UM TÍTULO PARA O VÍDEO PARA CONTINUAR");
        return;
      }
      // await this.saveQuestion();
      let formData = new FormData();
      this.file = this.$refs[`file${index}`][0].files[0];
      formData.append("video[file]", this.file);
      // return;
      this.questions[index].video = URL.createObjectURL(
        // document.querySelector(`#capture${index}`).files[0]
        this.file
      );

      let video = document.getElementById(`videoQuestion${index}`);

      video.load();

      video.onloadedmetadata = () => {
        // if (video.duration > 91 || video.duration == Infinity) {
        //   this.load = false;
        //   this.$toast.error(
        //     `Tempo de vídeo maior que 3 minutos, por favor grave um vídeo menor`
        //   );
        //   return;
        // }

        let q_current = this.currentQuestionParams(index);

        setTimeout(() => {
          let canvas = document.createElement("canvas");
          canvas.className = "hide";

          canvas.width = 320;
          canvas.height = 240;
          document.getElementsByTagName("body")[0].appendChild(canvas);
          canvas
            .getContext("2d")
            .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
          canvas.toBlob((thumb) => {
            axios
              .post("/recruiters/questions", {
                questions: {
                  job_id: this.job_id,
                  itens: [q_current],
                },
              })
              .then((response) => {
                this.questions[index].id = response.data.question.id;
                formData.append("video[thumbnail]", thumb);
                formData.append("video[name]", this.questions[index].title);
                formData.append("video[question_id]", this.questions[index].id);
                formData.append("video[job_id]", this.job_id);
                formData.append("video[recruiter_id]", 0);
                formData.append("video[account_id]", 0);
                axios
                  .post("/recruiters/question_videos", formData, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (progressEvent) => {
                      const totalLength = progressEvent.lengthComputable
                        ? progressEvent.total
                        : progressEvent.target.getResponseHeader(
                            "content-length"
                          ) ||
                          progressEvent.target.getResponseHeader(
                            "x-decompressed-content-length"
                          );

                      if (totalLength !== null) {
                        this.percent = parseInt(
                          (progressEvent.loaded * 100) / totalLength
                        );
                      }
                    },
                  })
                  .then((resp) => {
                    this.questions[index].video_id =
                      resp.data.question.video_id;
                    this.questions[index].video = resp.data.video;
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              });
          });
        }, 1100);
      };
    },
    deleteQuestion(index) {
      if (this.questions[index].id != 0) {
        let conf = confirm("TEM CERTEZA QUE DESEJA DELETAR ESSA PERGUNTA?");
        if (!conf) return;
        this.questions[index].deleted = true;
        eventBus.$emit("saveQuestion", this.questions);
        // axios
        //   .delete("/recruiters/questions/" + this.questions[index].id)
        //   .then((response) => {
        //     this.$toast.success("Pergunta removida com sucesso", {
        //       position: "top",
        //     });
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //     this.$toast.error("Pergunta não pode ser excluida", {
        //       position: "top",
        //     });
        //   });
      }
      this.questions.splice(index, 1);
    },
    addQuestion() {
      if (this.job_id === 0) return;

      axios
        .get("/recruiters/evaluations?job_id=" + this.job_id)
        .then(({ data }) => {
          this.evaluations = data.evaluations;
        });

      this.questions.push({
        id: 0,
        title: "",
        description: "",
        time: 30,
        number_retakers: 3,
        job_id: this.job_id,
        video: "",
        deleted: false,
        evaluation_id: null,
        selective_process_id: this.default_process_id,
        response_type: 0,
        time_to_respond: 0,
        is_mandatory: false,
        choices: {},
        tabs: [
          {
            name: "TEXTO",
            active: true,
          },
          {
            name: "VÍDEO",
            active: false,
            options: {
              record_now: false,
              upload_video: false,
            },
          },
        ],
      });
    },
    canVideo(index, page = "record_now") {
      if (this.questions[index].title == "") {
        this.$toast.error("DIGITE UM TÍTULO PARA O VÍDEO PARA CONTINUAR");
        return;
      }

      if (!this.job_id) {
        eventBus.$emit("saveJob", { index: index });

        setTimeout(() => {
          if (!this.job_id) {
            this.backMenuVideo(index);
          }
        }, 1100);
      }
      if (page) this.questions[index].tabs[1].options[page] = true;
    },
    backMenuVideo(index) {
      this.questions[index].tabs[1].options.record_now = false;
      this.questions[index].tabs[1].options.upload_video = false;
    },
    updateQuestions(saveQuestions = false, index = false) {
      if (index || index === 0) {
        let question = this.questions[index];
        if (question.choices.correctAnswer && question.response_type != 3) {
          this.questions[index].choices = {};
        }
      }

      this.$emit("input", this.questions);

      if (saveQuestions) eventBus.$emit("saveQuestion", false);
    },
  },
  watch: {
    job_id() {
      axios
        .get("/recruiters/evaluations?job_id=" + this.job_id)
        .then(({ data }) => {
          this.evaluations = data.evaluations;
        });
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
};
</script>
